module.exports = __webpack_public_path__ + "img/financed-by-eu.424f5d4f.jpg";